import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ModalContext } from "@/utils/contexts/ModalContext";
import ModalWrapperChildren from "@/views/components/Modal/ModalWrapperChildren";
import CloseIcon from '@/assets/icons/simpleTextAdvices/close_icon.svg';
import { formatTimeDate } from "@/utils/functions/formatTimeDate";

const ModalMetadataView = () => {
	const [ paramsArr, setParamsArr ] = useState([]);
	const { dict: { titletypes, letter: { metadata } } } = useSelector((state) => state.app);

	const { closeModal, modalAdditionalInfo } = useContext(ModalContext);

	const { recipientsDict, categoriesDict } = useSelector(state => state.data);

	useEffect(() => {
		if (modalAdditionalInfo.letterData) {
			const {
				title,
				titleType,
				category,
				date,
				department: { name },
				recipient,
				author,
				owner: {
					displayName,
					email,
				},
				createdOn,
				modifiedOn,
			} = modalAdditionalInfo.letterData;

			setParamsArr([
				{ id: 'metadataTitle', label: metadata?.title, value: title },
				{ id: 'metadataTitleType', label: metadata?.titleType, value: titletypes[titleType.replaceAll('-', '')]  },
				{ id: 'metadataCategory', label: metadata?.category, value: categoriesDict[category.code] },
				{ id: 'metadataWritingDate', label: metadata?.writingDate, value: formatTimeDate(date) },
				{ id: 'metadataAuthor', label: metadata?.writingAuthor, value: `${author?.forename || ''} ${author?.surname || ''}`},
				{ id: 'metadataDepartment', label: metadata?.department, value: name },
				{ id: 'metadataRecipient', label: metadata?.recipient, value: recipientsDict[recipient.code], hasDivider: true },
				{ id: 'metadataIntroductory', label: metadata?.introductory, value: `${displayName}, ${email}` },
				{ id: 'metadataAddedDate', label: metadata?.addedDate, value: formatTimeDate(createdOn) },
				{ id: 'metadataEditData', label: metadata?.editData, value: formatTimeDate(modifiedOn) },
			]);
		}
	}, [ modalAdditionalInfo.letterData ]);
	return (
		<ModalWrapperChildren
			onClose={ closeModal }
			modalVisible={ true }
			title={
				<div className="modal-metadata-view__header">
					{metadata.modalTitle}
					<button 
						onClick={ closeModal } 
						className="modal-metadata-view__close-modal-btn"
					>
						<img 
							src={ CloseIcon } 
							alt="close-icon" 
						/>
					</button>
				</div>
			}
		>
			<ul className="modal-metadata-view__list">
				{paramsArr.map(({ id, label, value, hasDivider }) => (
					<React.Fragment key={ id }>
						<li
							className="modal-metadata-view__list-item"
						>
							<span
								className="modal-metadata-view__list-item-text--label"
							>
								{label}:
							</span>
							<span className="modal-metadata-view__list-item-text--value">
								{(value && value.trim() !== '') ? value : metadata.none}
							</span>
						</li>
						{hasDivider && (
							<hr
								className="modal-metadata-view__list-item-divider"
							/>
						)}
					</React.Fragment>
				))}
			</ul>
		</ModalWrapperChildren>
	);
};

export default ModalMetadataView;
